/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для блока изменения пароля в кабинете
   */
  app.ChangePasswordView = app.View.extend({
    el: '#change-password',
    
    run: function () {
      new als.Popup(this.$('.popup1'), this.$('.opener1'));
      new app.ChangePasswordFormView();
    }
  });
})();

}.call(window));